import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useState } from '@redneckz/uni-jsx/lib/hooks';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { Heading } from '../../ui-kit/Heading/Heading.js';
import { style } from '../../utils/style.js';
import { InsuranceAmountBlockInner } from './InsuranceAmountBlockInner.js';
export const InsuranceAmountBlock = JSX(({ className = '', title, insuranceTabs = [], button, ...rest }) => {
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);
    const handleActiveSlideIndex = useCallback((_) => setActiveSlideIndex(_), []);
    return (_jsxs(BlockWrapper, { className: style('box-border overflow-hidden relative px-0 space-y-2xl', className), defaultPadding: "p-6xl", ...rest, children: [title ? _jsx(Heading, { className: "text-center", title: title, headingType: "h3" }) : null, insuranceTabs?.length > 1 ? (_jsx("div", { className: "p-xs bg-secondary-light w-fit mx-auto rounded-md", children: insuranceTabs.map((item, i) => renderNavButton({
                    title: item?.title,
                    i,
                    isActive: Boolean(i === activeSlideIndex),
                    onClick: () => handleActiveSlideIndex(i),
                })) })) : null, _jsx("div", { className: "flex", style: { transform: `translateX(-${activeSlideIndex}00%)` }, role: "list", children: renderInsuranceGalleries({
                    insuranceTabs,
                    button,
                }) })] }));
});
const renderInsuranceGalleries = ({ insuranceTabs, button }) => {
    const insuranceGalleries = insuranceTabs?.map((_) => _.cards);
    return insuranceGalleries?.length
        ? insuranceGalleries.map((cards, i) => (_jsx(InsuranceAmountBlockInner, { button: button, cards: cards }, String(i))))
        : null;
};
function renderNavButton({ title, i, isActive, onClick }) {
    const btnClassName = isActive ? 'bg-primary-main text-white rounded-md' : `text-secondary-text`;
    return (_jsx("button", { type: "button", onClick: onClick, "aria-label": `Кнопка ${title}`, className: `box-border px-m py-s text-m font-light ${btnClassName}`, children: title }, String(i)));
}
//# sourceMappingURL=InsuranceAmountBlock.js.map